import './Loading.css';
const Loading = () => {
    return (
        <>
        <div className='loading-page'> 
        <span className="loader"></span>
        </div>
        </>
    )
}

export default Loading;